import { RolesManyToMany } from "../types/auth.types";
import { UserFromAPI } from "../types/auth.types";
import { NIC_USERS, ROLES } from "../utils/constants";
import { formatDate } from "../utils/dateUtils";
import { Process } from "./types";

export const processUpdatedAt = (process: Process) => {
  const updatedAt = process.date_updated || process.date_created;
  return formatDate(updatedAt);
};

export const extractUsersFromRoles = (roles: RolesManyToMany) => {
  const combinedUsers: Array<UserFromAPI> = [];

  if (!roles) {
    return combinedUsers;
  }

  roles.forEach((role) => {
    const userRoles = role.directus_roles_id.users;

    if (userRoles) {
      userRoles.forEach((user) => {
        if (user.status === "active") {
          combinedUsers.push(user);
        }
      });
    }
  });

  return combinedUsers;
};

export const applyResponsiveImageStyles = (content: string): string => {
  if (!content.includes("<img")) return content;

  const newTag = content.replace(/<img[^>]+>/g, (imgTag) => {
    let newImgTag = imgTag
      .replace(/\swidth="[^"]*"/g, "")
      .replace(/\sheight="[^"]*"/g, "")
      .replace(/\swidth='[^']*'/g, "")
      .replace(/\sheight='[^']*'/g, "")
      .replace(/\swidth=\S+/g, "")
      .replace(/\sheight=\S+/g, "");

    const responsiveStyles = "max-width: 100%; height: auto;";

    if (newImgTag.includes("style=")) {
      return newImgTag
        .replace(/style="([^"]*)"/g, (_, existingStyles) => {
          return `style="${existingStyles}${existingStyles.endsWith(";") ? " " : "; "}${responsiveStyles}"`;
        })
        .replace(/style='([^']*)'/g, (_, existingStyles) => {
          return `style='${existingStyles}${existingStyles.endsWith(";") ? " " : "; "}${responsiveStyles}'`;
        });
    } else {
      return newImgTag.replace("<img", `<img style="${responsiveStyles}"`);
    }
  });

  return newTag;
};

const parentCategoriesUnderRoleSupervision: Record<number, string> = {
  // Reception and client support
  1: ROLES.technical_director,
};

export const checkParentCategoriesUnderRoleSupervision = (userRoleId: string | undefined, parentCategoryId: number) => {
  if (!userRoleId) return false;
  const supervisedRole = parentCategoriesUnderRoleSupervision[parentCategoryId];
  const isMatch = supervisedRole === userRoleId;
  return isMatch;
};

const parentCategoriesCanEdit: Record<number, Array<string>> = {
  2: [NIC_USERS.daniela_lemos],
  11: [NIC_USERS.daniela_lemos]
};

export const checkSpecialUsersCanEditParentCategories = (userId: string | undefined, parentCategoryId: number) => {
	if (!userId) return false;
	const selectedCategory = parentCategoriesCanEdit[parentCategoryId]
	if (!selectedCategory) return false
	const isMatch = selectedCategory.includes(userId)
	return isMatch


}
